/* eslint-disable no-use-before-define */
/* eslint-disable no-self-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-return-assign */
import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SessionStore from 'stores/SessionStore';
import Alert from 'components/ui/Alert';
import LoadingCircle from 'components/ui/LoadingCircle';
import _ from 'lodash';
import WebAPIUtils from 'utils/AccessorialRequestWebAPIUtils';
import LocationWebAPIUtils from 'utils/LocationWebAPIUtils';
import moment from 'moment-timezone';
import { showToast } from 'stores/ToastStore';
import { findUsers } from 'utils/UserWebAPIUtils';
import { validateDocumentFilesSizes } from 'utils/documents';
import DropdownMenu from 'components/v2/dropdowns/DropdownMenu';
import DropdownItem from 'components/v2/dropdowns/DropdownItem';
import { Menu } from '@headlessui/react';
import { useHistory } from 'react-router-dom';
import { getIsNewFscFlow } from 'utils/FscSettingsApiUtils';
import Tooltip from 'components/v2/Tooltip';

import LaneRatesList from './LaneRatesList';
import UpdateLaneRatesModal from '../carrier/modals/UpdateLaneRatesModal';
import AuditTrailModal from './modals/LaneRateAuditTrailModal';
import { LaneRatesCsvUploadModal } from './LaneRatesCsvUploadModal';

const PER_PAGE = 20;
const UPDATE = 'update';
const CREATE = 'create';
const MANDATORY_FIELDS = [
  'customer',
  'originZone',
  'destinationZone',
  'rate',
  'reversible',
  'effectiveStart',
  'effectiveEnd',
];
const defaultLaneRate = {
  customer: '',
  customerType: '',
  name: '',
  originZone: '',
  originState: '',
  originStreet: '',
  destinationZone: '',
  destinationState: '',
  destinationStreet: '',
  rate: 0,
  fsc: '',
  fscFlatRate: '',
  reversible: '',
  weeklyCommitment: 0,
  createdAt: '',
  updatedAt: '',
  status: '',
};

export default function Table(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [checkAll, setCheckAll] = useState(false);
  const [selectedRates, setSelectedRates] = useState([]);
  const [showActionField, setShowActionField] = useState(false);
  const [showCreateNewLaneRateModal, setShowCreateNewLaneRateModal] =
    useState(false);
  const [showEditRateModal, setShowEditRateModal] = useState(false);
  const [defaultRate, setDefaultRate] = useState([defaultLaneRate]);
  const [missingRequiredFields, setMissingRequiredFields] = useState(false);
  const [disableFooterButtons, setDisableFooterButtons] = useState(true);
  const [filesUploaded, setFilesUploaded] = useState();
  const [rateAudit, setRateAudit] = useState();
  const [showAuditTrailModal, setShowAuditTrailModal] = useState(false);
  const [loadingConfirmation, setLoadingConfirmation] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [canUpload, setCanUpload] = useState(
    SessionStore.isAbleToUploadCSVLaneRates(),
  );
  const history = useHistory();
  const [isNewFscFlow, setIsNewFscFlow] = useState(null);
  const [laneRatesUploadingModalOpen, setLaneRatesUploadingModalOpen] =
    useState(false);

  useEffect(() => {
    (async () => {
      const isNewFscFlow = await getIsNewFscFlow();
      setIsNewFscFlow(isNewFscFlow);
    })();
  }, []);

  function setFilterQueryParameters() {
    const {
      originZip,
      destinationZip,
      originZone,
      destinationZone,
      customer,
      status,
      customerType,
    } = props;
    let filterString = {};
    if (originZip) {
      filterString.originZip = originZip;
    }
    if (destinationZip) {
      filterString.destinationZip = destinationZip;
    }
    if (customer) {
      filterString.customer = customer;
    }
    if (originZone) {
      filterString.originZone = originZone;
    }
    if (destinationZone) {
      filterString.destinationZone = destinationZone;
    }
    if (status) {
      filterString.status = status;
    }
    if (customerType) {
      filterString.customerType = customerType;
    }
    filterString = new URLSearchParams(filterString).toString();
    return filterString;
  }

  function getFilterString(applyPagination = true) {
    let filterString = setFilterQueryParameters();
    if (sortColumn && sortDirection) {
      const sortAttributes = {
        sortColumn,
        sortDirection,
      };
      const sortString = new URLSearchParams(sortAttributes).toString();
      filterString = `${sortString}${filterString ? `&${filterString}` : ''}`;
    }
    if (applyPagination) {
      const paginationString = `per_page=${PER_PAGE}&skip=${skip}`;
      filterString = `${paginationString}${
        filterString ? `&${filterString}` : ''
      }`;
    }
    return filterString;
  }

  async function getLaneRates(queryParams) {
    const start = new Date();
    const response = await WebAPIUtils.getUserLaneRatesV2(queryParams);
    const stop = new Date();
    console.log(`Time Taken to execute = ${stop - start} ms.`);
    return response;
  }
  async function getUserLaneRates() {
    const requestQuery = getFilterString();
    debouncedQuery(requestQuery);
  }

  const debouncedQuery = useMemo(() => {
    return _.debounce(async (requestQuery) => {
      const response = await getLaneRates(requestQuery);
      if (response) {
        const { laneRates, count } = response;
        setItems(laneRates);
        setPages(Math.ceil(count / PER_PAGE));
        setTotal(count);
      }
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    setLoading(true);
    // props.setLoadingItems(true);
    getUserLaneRates();
  }, [
    page,
    skip,
    sortColumn,
    sortDirection,
    props.customer,
    props.customer,
    props.customerType,
    props.originZone,
    props.destinationZone,
    props.status,
  ]);

  useEffect(() => {
    const checked = items?.filter((item) => item.checked === true);
    const showActionField = !!checked?.length;
    setShowActionField(showActionField);
  }, [items]);

  function handlePageClick(selectedPage) {
    setLoading(true);
    // props.setLoadingItems(true);
    setPage(selectedPage);
    setSkip(((selectedPage || page) - 1) * PER_PAGE);
  }

  function handleToggleCheck(item, i) {
    setItems((prev) => {
      return [
        ...prev.slice(0, i),
        {
          ...item,
        },
        ...prev.slice(i + 1),
      ];
    });
    setCheckAll(
      // checks every checkbox in the array except the one being changed in which case it checks against the item parameter
      items?.every((cb, index) => (index === i ? item.checked : cb.checked)),
    );
  }

  function handleToggleCheckAll(checked) {
    setItems((prev) => {
      return prev.map((item) => ({ ...item, checked }));
    });
    setCheckAll(checked);
  }

  function handleAddNewRates() {
    if (isNewFscFlow) {
      const {
        originZone,
        destinationZone,
        customers,
        customerTypes,
        statuses,
      } = props;
      history.push('/lane-rates/add', {
        listQueryFilterParameters: {
          originZone,
          destinationZone,
          customers,
          customerTypes,
          statuses,
        },
      });
    } else {
      setShowCreateNewLaneRateModal(true);
    }
  }

  async function exportLaneRates() {
    const requestQuery = getFilterString(false);
    try {
      await WebAPIUtils.exportUserLaneRates(requestQuery);
      showToast(t('CSV_DOWNLOAD_SUCCESSFUL'), null, 'success');
    } catch (error) {
      showToast(t('CSV_DOWNLOAD_FAILED'), null, 'error');
    }
  }

  function handleHideCreateNewLaneRateModal() {
    setDefaultRate([defaultLaneRate]);
    setShowCreateNewLaneRateModal(false);
  }

  function handleHideUpdateLaneRateModal() {
    const ratesArray = selectedRates;
    ratesArray.map((rate) => {
      return rate.checked ? (rate.checked = false) : '';
    });
    setSelectedRates([]);
    setShowEditRateModal(false);
    setShowActionField(false);
  }

  function handleBulkLaneRateUpdate() {
    let selected = items?.filter((item) => item.checked);

    if (isNewFscFlow) {
      const {
        originZone,
        destinationZone,
        customers,
        customerTypes,
        statuses,
      } = props;
      history.push('/lane-rates/edit', {
        laneRates: selected.map((laneRate) => ({
          ...laneRate,
          weeklyCommitment: laneRate.commitment,
        })),
        listQueryFilterParameters: {
          originZone,
          destinationZone,
          customers,
          customerTypes,
          statuses,
        },
      });
      return;
    }

    if (selected?.length) {
      selected = _.map(selected, (laneRate) => {
        laneRate.rate = `${laneRate.rate}`;
        laneRate.fsc == null
          ? (laneRate.fsc = '')
          : (laneRate.fsc = `${laneRate.fsc}`);
        laneRate.fscFlatRate == null
          ? (laneRate.fscFlatRate = '')
          : (laneRate.fscFlatRate = laneRate.fscFlatRate);
        laneRate.reversible === false
          ? (laneRate.reversible = 'No')
          : (laneRate.reversible = 'Yes');
        laneRate.document == null
          ? (laneRate.document = '')
          : (laneRate.oldDocument = laneRate.document);
        laneRate.document = '';
        laneRate.commitment == null
          ? (laneRate.weeklyCommitment = 0)
          : (laneRate.weeklyCommitment = laneRate.commitment);
        return laneRate;
      });
      setSelectedRates(selected);
      setShowEditRateModal(true);
    }
  }

  const handleAddNewRatesLine = (type) => {
    type === CREATE
      ? setDefaultRate([...defaultRate, defaultLaneRate])
      : setSelectedRates([...selectedRates, defaultLaneRate]);
  };

  const onLaneRateFieldChange = (index) => (field, value, modalType) => {
    const currentLaneRates =
      modalType === CREATE ? [...defaultRate] : [...selectedRates];

    const itemData = {
      ...currentLaneRates[index],
      [field]: field === 'weeklyCommitment' ? Number(value) : value,
    };

    currentLaneRates[index] = itemData;

    modalType === CREATE
      ? setDefaultRate(currentLaneRates)
      : setSelectedRates(currentLaneRates);
    // handleRequiredFieldValidation(modalType);
  };

  const onZoneBlur = async (zip) => {
    return LocationWebAPIUtils.zipToCityState(zip);
  };

  const handleDateFieldChange = (index) => (field, value, modalType) => {
    const currentLaneRates =
      modalType === CREATE ? [...defaultRate] : [...selectedRates];
    const selectedValue = value ? value._d : null;
    if (selectedValue) {
      const dateVal = moment(value._d).seconds(0).format();
      const itemData = {
        ...currentLaneRates[index],
        [field]: dateVal,
      };
      currentLaneRates[index] = itemData;
      modalType === CREATE
        ? setDefaultRate(currentLaneRates)
        : setSelectedRates(currentLaneRates);
    } else {
      const itemData = {
        ...currentLaneRates[index],
        [field]: selectedValue,
      };
      currentLaneRates[index] = itemData;
      modalType === CREATE
        ? setDefaultRate(currentLaneRates)
        : setSelectedRates(currentLaneRates);
    }
    // handleRequiredFieldValidation(modalType);
  };
  const handleRequiredFieldValidation = (modalType) => {
    let availableLaneRates = modalType === CREATE ? defaultRate : selectedRates;
    availableLaneRates = _.map(availableLaneRates, (laneRate) => {
      laneRate.isValid = handleObject(laneRate);
      return laneRate;
    });
    const noMissingFields = availableLaneRates?.every(
      (laneRate) => laneRate.isValid,
    );
    if (noMissingFields) {
      setMissingRequiredFields(false);
      setDisableFooterButtons(false);
    } else {
      setMissingRequiredFields(true);
      setDisableFooterButtons(true);
    }
  };

  useEffect(() => {
    handleRequiredFieldValidation(showCreateNewLaneRateModal ? CREATE : UPDATE);
  }, [selectedRates, defaultRate]);

  const handleAddressUpdate = (index) => (type, item, modalType) => {
    let zipcode = '';
    let state = '';
    if (item) {
      zipcode = item.zipcode;
      state = item.state;
    }
    modalType === CREATE
      ? handleCreateAddress(index, zipcode, state, type)
      : handleEditAddress(index, zipcode, state, type);
    // handleRequiredFieldValidation(modalType);
  };

  const handleCreateAddress = (index, zipcode, state, type) => {
    const currentLaneRates = [...defaultRate];
    let laneRate = {
      ...defaultRate[index],
      [`${type}Zip`]: zipcode,
      [`${type}State`]: state,
    };
    currentLaneRates[index] = laneRate;
    setDefaultRate(currentLaneRates);
  };

  const handleEditAddress = (index, zipcode, state, type) => {
    const currentLaneRates = [...selectedRates];
    let laneRate = {
      ...selectedRates[index],
      [`${type}Zip`]: zipcode,
      [`${type}State`]: state,
    };
    currentLaneRates[index] = laneRate;
    setSelectedRates(currentLaneRates);
  };

  const handleCustomerField = (index) => (type, item, value, modalType) => {
    const currentLaneRates = modalType === CREATE ? defaultRate : selectedRates;
    let customer = '';
    let customerType = '';
    let customerName = '';
    let laneRate;
    if (value) {
      customer = value.id ? value.id : value._id;
      customerType = value.type;
      customerName = value.account_name ? value.account_name : value.name;
    }
    if (type === 'customer' && modalType === CREATE) {
      laneRate = {
        ...defaultRate[index],
        customer: customer,
        customerType: customerType,
        name: customerName,
      };
    } else {
      laneRate = {
        ...selectedRates[index],
        customer: customer,
        customerType: customerType,
        name: customerName,
      };
    }
    currentLaneRates[index] = laneRate;
    modalType === CREATE
      ? setDefaultRate(currentLaneRates)
      : setSelectedRates(currentLaneRates);
    // (modalType);
  };

  const handleApplyAll = (index) => (modalType) => {
    const currentLaneRates = modalType === CREATE ? defaultRate : selectedRates;
    const updatedLaneRates = currentLaneRates.map((currentLaneRate) => {
      return {
        ...currentLaneRates[index],
        updatedAt: currentLaneRate.updatedAt,
        createdAt: currentLaneRate.createdAt,
        checked: currentLaneRate.checked,
      };
    });
    modalType === CREATE
      ? setDefaultRate(updatedLaneRates)
      : setSelectedRates(updatedLaneRates);
    // handleRequiredFieldValidation(modalType);
  };

  const handleRemoveLane = (index) => (modalType) => {
    const currentLaneRates = handleLanesAdjustment(index, modalType);
    modalType === CREATE
      ? setDefaultRate(currentLaneRates)
      : setSelectedRates(currentLaneRates);
    // handleRequiredFieldValidation(modalType);
  };

  const handleLanesAdjustment = (index, modalType) => {
    const currentLaneRates = modalType === CREATE ? defaultRate : selectedRates;
    if (currentLaneRates?.length > 1 && index > -1) {
      return currentLaneRates
        .slice(0, index)
        .concat(currentLaneRates.slice(index + 1))
        .map((s, i) => {
          return { ...s, sequence: i + 1 };
        });
    }
    return currentLaneRates;
  };

  const handleComplete = (files) => {
    setFilesUploaded(files);
  };

  const handleObject = (data) => {
    let numericalFieldsValid = true;
    const requiredFieldsComplete = Object.values(MANDATORY_FIELDS)?.every(
      (field) => {
        return data[field];
      },
    );

    if (parseInt(data.rate, 10) && data.rate < 0) {
      numericalFieldsValid = false;
    }

    if (parseInt(data.fsc, 10) && data.fsc < 0) {
      numericalFieldsValid = false;
    }

    if (requiredFieldsComplete) {
      if (
        moment(data.effectiveEnd).isSameOrBefore(data.effectiveStart, 'day')
      ) {
        numericalFieldsValid = false;
      }
    }

    return requiredFieldsComplete && numericalFieldsValid;
  };

  async function fetchCustomerEmail(availableLaneRates) {
    let customers = [];
    const customersId = _.map(availableLaneRates, 'customer');
    const userData = await findUsers({ _id: { $in: customersId } });
    if (userData?.entity?.items?.length > 0) {
      _.map(userData?.entity?.items, (data) => {
        const foundCustomers = _?.filter(availableLaneRates, {
          customer: data.id ? data.id : data._id,
        });
        _.map(foundCustomers, (customer) => {
          customer.customerEmail = data.email;
          customers.push(customer);
        });
      });
    } else {
      customers = availableLaneRates;
    }
    return customers;
  }

  async function handleAlreadyConfirmed(modalType) {
    setUploadingFiles(true);
    let availableLaneRates = modalType === CREATE ? defaultRate : selectedRates;
    availableLaneRates = _.map(availableLaneRates, (laneRate) => {
      laneRate.isValid = handleObject(laneRate);
      laneRate.alreadyConfirmed = true;
      return laneRate;
    });
    const noMissingFields = availableLaneRates?.every(
      (laneRate) => laneRate.isValid,
    );

    try {
      validateDocumentFilesSizes(filesUploaded);
    } catch (e) {
      setUploadingFiles(false);
      return;
    }

    if (noMissingFields) {
      try {
        setMissingRequiredFields(false);
        let customers = await fetchCustomerEmail(availableLaneRates);
        const postUpdateLaneRates = await WebAPIUtils.alreadyConfirmedLaneRates(
          customers,
          filesUploaded,
          modalType,
        );
        if (postUpdateLaneRates?.success) {
          showToast(
            t('REQUEST_SUCCESS'),
            t('LANE_RATE_SUBMIT_SUCCESS'),
            'success',
          );
          await getUserLaneRates();
          modalType === CREATE
            ? handleHideCreateNewLaneRateModal()
            : handleHideUpdateLaneRateModal();
        } else {
          showToast(t('REQUEST_ERROR'), t('LANE_RATE_UPDATE_ERROR'), 'error');
        }
        setUploadingFiles(false);
      } catch (e) {
        setUploadingFiles(false);
        showToast(t('REQUEST_ERROR'), t('LANE_RATE_UPDATE_ERROR'), 'error');
        console.log(e);
      }
    } else {
      setUploadingFiles(false);
      setMissingRequiredFields(true);
    }
  }

  async function handleSave(modalType) {
    setLoadingConfirmation(true);
    let availableLaneRates = modalType === CREATE ? defaultRate : selectedRates;
    availableLaneRates = _.map(availableLaneRates, (laneRate) => {
      laneRate.isValid = handleObject(laneRate);
      laneRate.alreadyConfirmed = false;
      return laneRate;
    });
    const noMissingFields = availableLaneRates?.every(
      (laneRate) => laneRate.isValid,
    );
    if (noMissingFields) {
      try {
        setMissingRequiredFields(false);
        let customers = await fetchCustomerEmail(availableLaneRates);
        const postUpdateLaneRates = await WebAPIUtils.updateLaneRates(
          customers,
          modalType,
        );
        if (postUpdateLaneRates?.success) {
          showToast(
            t('REQUEST_SUCCESS'),
            t('LANE_RATE_SUBMIT_SUCCESS'),
            'success',
          );
          await getUserLaneRates();
          modalType === CREATE
            ? handleHideCreateNewLaneRateModal()
            : handleHideUpdateLaneRateModal();
        } else {
          showToast(t('REQUEST_ERROR'), t('LANE_RATE_UPDATE_ERROR'), 'error');
        }
        setLoadingConfirmation(false);
      } catch (e) {
        setLoadingConfirmation(false);
        showToast(t('REQUEST_ERROR'), t('LANE_RATE_UPDATE_ERROR'), 'error');
        console.log(e);
      }
    } else {
      setLoadingConfirmation(false);
      setMissingRequiredFields(true);
    }
  }

  async function handleEdit(item, index) {
    let selectedItem = [item];

    if (isNewFscFlow) {
      const {
        originZone,
        destinationZone,
        customers,
        customerTypes,
        statuses,
      } = props;
      history.push('/lane-rates/edit', {
        laneRates: selectedItem.map((laneRate) => ({
          ...laneRate,
          weeklyCommitment: laneRate.commitment,
        })),
        listQueryFilterParameters: {
          originZone,
          destinationZone,
          customers,
          customerTypes,
          statuses,
        },
      });
      return;
    }

    selectedItem = _.map(selectedItem, (laneRate) => {
      laneRate.rate = `${laneRate.rate}`;
      laneRate.fsc == null
        ? (laneRate.fsc = '')
        : (laneRate.fsc = `${laneRate.fsc}`);
      laneRate.fscFlatRate == null
        ? (laneRate.fscFlatRate = '')
        : (laneRate.fscFlatRate = laneRate.fscFlatRate);
      laneRate.reversible === false
        ? (laneRate.reversible = 'No')
        : (laneRate.reversible = 'Yes');
      laneRate.document == null
        ? (laneRate.document = '')
        : (laneRate.oldDocument = laneRate.document);
      laneRate.document = '';
      laneRate.commitment == null
        ? (laneRate.weeklyCommitment = 0)
        : (laneRate.weeklyCommitment = laneRate.commitment);
      return laneRate;
    });
    setSelectedRates(selectedItem);
    setShowEditRateModal(true);
  }

  function handleAuditClick(item, index) {
    setRateAudit(item);
    setShowAuditTrailModal(true);
  }

  function toggleSort(sortDirection, title) {
    setSortDirection(sortDirection);
    setSortColumn(title);
  }

  function renderEmptyList() {
    return <div className="p-4">{t('EMPTY_STATE')}</div>;
  }

  function canUpdate() {
    const isShipperLanePricingManager =
      SessionStore.isShipperLanePricingManager();
    const isCarrierLanePricingManager =
      SessionStore.isCarrierLanePricingManager();
    const selectedItems = items?.filter((item) => item.checked);

    if (
      (isShipperLanePricingManager || isCarrierLanePricingManager) &&
      !(isShipperLanePricingManager && isCarrierLanePricingManager)
    ) {
      return (
        (selectedItems?.every((item) => item.customerType === 'shipper') &&
          isShipperLanePricingManager) ||
        (selectedItems?.every((item) => item.customerType === 'carrier') &&
          isCarrierLanePricingManager)
      );
    }

    return SessionStore.isAbleToEditLaneRate();
  }

  if (!SessionStore.isAdmin()) {
    return (
      <div className="p-4">
        <Alert title={t('REQUIRE_PERMISSION_TO_VIEW_PAGE')} type="error" />
      </div>
    );
  }

  const loadingText = `${t('LOADING')}...`;
  return (
    <div className="bg-white rounded-md shadow divide-y divide-solid divide-gray-200 relative">
      <div className="absolute right-3 top-3 md:px-10">
        <DropdownMenu title={t('ACTIONS')}>
          <Menu.Item key="update">
            <DropdownItem
              onClick={() => handleBulkLaneRateUpdate()}
              disabled={!showActionField || !canUpdate()}
            >
              {t('UPDATE')}
            </DropdownItem>
          </Menu.Item>
          <Menu.Item key="add">
            <DropdownItem onClick={handleAddNewRates} disabled={!canUpdate()}>
              {t('ADD_NEW_LANE_RATE')}
            </DropdownItem>
          </Menu.Item>
          <Menu.Item key="export">
            <Tooltip
              body={() => {
                return (
                  <DropdownItem
                    disabled={total > 5000}
                    onClick={exportLaneRates}
                    id="rate-table-reversible"
                    position="left"
                  >
                    {t('EXPORT_LANE_RATES')}
                  </DropdownItem>
                );
              }}
            >
              {t('EXPORT_IS_LIMITED')}
            </Tooltip>
          </Menu.Item>
          {canUpload && (
            <Menu.Item key="upload">
              <DropdownItem
                onClick={() => setLaneRatesUploadingModalOpen(true)}
              >
                <div>{t('UPLOAD_LANE_RATES')}</div>
              </DropdownItem>
            </Menu.Item>
          )}
        </DropdownMenu>
      </div>
      {!loading && (
        <LaneRatesList
          items={items}
          onPageClick={handlePageClick}
          perPage={PER_PAGE}
          page={page}
          pages={pages}
          toggleSort={toggleSort}
          sortDirection={sortDirection}
          sortColumn={sortColumn}
          total={total}
          onToggleCheck={handleToggleCheck}
          onToggleCheckAll={handleToggleCheckAll}
          onEdit={handleEdit}
          checkAll={checkAll}
          setRateAudit={handleAuditClick}
          isNewFscFlow={isNewFscFlow}
          canUpdate={canUpdate()}
        />
      )}
      <AuditTrailModal
        show={showAuditTrailModal}
        rate={rateAudit}
        onHide={() => setShowAuditTrailModal(false)}
        type="laneRates"
      />

      {showCreateNewLaneRateModal && (
        <UpdateLaneRatesModal
          modalType={CREATE}
          itemMetaData={defaultRate}
          showModal={showCreateNewLaneRateModal}
          onSave={handleSave}
          onClickAlreadyConfirmed={handleAlreadyConfirmed}
          onComplete={handleComplete}
          onClose={handleHideCreateNewLaneRateModal}
          onAddRate={handleAddNewRatesLine}
          onFieldChange={onLaneRateFieldChange}
          onZoneBlur={onZoneBlur}
          onChangeDateField={handleDateFieldChange}
          onChangeAddress={handleAddressUpdate}
          onChangeCustomer={handleCustomerField}
          onClickApplyAll={handleApplyAll}
          onClickRemoveLane={handleRemoveLane}
          missingRequiredFields={missingRequiredFields}
          loadingConfirmation={loadingConfirmation}
          uploadingFiles={uploadingFiles}
          disableButtons={disableFooterButtons}
        />
      )}
      {showEditRateModal && (
        <UpdateLaneRatesModal
          modalType={UPDATE}
          itemMetaData={selectedRates}
          showModal={showEditRateModal}
          onSave={handleSave}
          onClickAlreadyConfirmed={handleAlreadyConfirmed}
          onComplete={handleComplete}
          onClose={handleHideUpdateLaneRateModal}
          onAddRate={handleAddNewRatesLine}
          onFieldChange={onLaneRateFieldChange}
          onZoneBlur={onZoneBlur}
          onChangeDateField={handleDateFieldChange}
          onChangeAddress={handleAddressUpdate}
          onChangeCustomer={handleCustomerField}
          onClickApplyAll={handleApplyAll}
          onClickRemoveLane={handleRemoveLane}
          missingRequiredFields={missingRequiredFields}
          loadingConfirmation={loadingConfirmation}
          uploadingFiles={uploadingFiles}
          disableButtons={disableFooterButtons}
        />
      )}

      {laneRatesUploadingModalOpen && (
        <LaneRatesCsvUploadModal
          onClose={() => setLaneRatesUploadingModalOpen(false)}
        />
      )}

      {loading && (
        <div className="p-4">
          <LoadingCircle text={loadingText} />
        </div>
      )}
      {!total && !loading && renderEmptyList()}
    </div>
  );
}
